const ChatItem = ({ convo, active, onClick }) => {
  const name = convo?.other_user?.username || convo?.name || "Unknown";
  const avatar = convo?.other_user?.profile?.avatar;
  const lastMsg = convo?.last_message?.text || "No messages yet";
  const time = convo?.last_message?.created_at
    ? new Date(convo.last_message.created_at).toLocaleTimeString([], {
        hour: "2-digit", minute: "2-digit",
      })
    : "";

  return (
    <button
      onClick={onClick}
      onMouseEnter={e => { if (!active) e.currentTarget.style.backgroundColor = 'oklch(27.1% 0.105 12.094)'; }}
      onMouseLeave={e => { if (!active) e.currentTarget.style.backgroundColor = ''; }}
      className={`w-full flex items-center gap-3 px-4 py-3 rounded-2xl
        transition-all duration-200 text-left
        ${active ? "bg-white/10" : ""}`}
    >
      {/* Avatar */}
      <div className="w-12 h-12 rounded-full overflow-hidden bg-white/10 shrink-0
        flex items-center justify-center">
        {avatar ? (
          <img src={avatar} alt={name} className="w-full h-full object-cover" />
        ) : (
          <span className="text-white font-bold text-lg">
            {name[0]?.toUpperCase()}
          </span>
        )}
      </div>

      {/* Info */}
      <div className="flex-1 min-w-0">
        <div className="flex justify-between items-center">
          <p className="text-white font-semibold text-sm truncate">{name}</p>
          <span className="text-white/30 text-xs shrink-0 ml-2">{time}</span>
        </div>
        <p className="text-white/40 text-xs truncate mt-0.5">{lastMsg}</p>
      </div>
    </button>
  );
};

export default ChatItem;